import { render, staticRenderFns } from "./DeleteInside.vue?vue&type=template&id=070a8f86&scoped=true&"
import script from "./DeleteInside.vue?vue&type=script&lang=js&"
export * from "./DeleteInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a8f86",
  null
  
)

export default component.exports